// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/close_modal_White.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("images/stripe_supported_cards.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("images/tink_payments_icon2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("images/checkmark_deepSeaGreen.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("images/header_underline.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("images/header_background.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("images/header_doubleLines.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Arvo&family=Baskervville&family=Bitter&family=Fahkwang&family=Georama&family=IBM+Plex+Sans+Condensed&family=Krub&family=Libre+Baskerville&family=Open+Sans&family=Playfair+Display&family=Poppins&family=Quicksand&family=Roboto&family=Roboto+Condensed&family=Roboto+Mono&family=Rokkitt&family=Sen&family=Solway&family=Space+Mono&family=Varela+Round&family=Volkhov&family=Work+Sans&family=Zilla+Slab&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.Modal > div.window {
  border: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
}

div.Modal > div.overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(38, 40, 47, 0.75);
  z-index: 3000;
}
div.Modal > div.window {
  border: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
  background-color: #FFF;
  position: fixed;
  max-height: calc(100% - 20px);
  right: auto;
  -webkit-box-shadow: 2px 2px 5px #5F6766;
          box-shadow: 2px 2px 5px #5F6766;
  overflow: auto;
  z-index: 3001;
}
div.Modal > div.window.fullscreen {
  width: 100% !important;
  left: 0 !important;
  height: 100% !important;
  max-height: 100% !important;
}
div.Modal > div.window.fullscreen content {
  height: 100vh;
}
div.Modal > div.window.fullscreen footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #FFF;
}
div.Modal > div.window.extra-wide {
  width: 1167px;
  left: calc(50% - 583.5px);
}
div.Modal > div.window.wide {
  width: 900px;
  left: calc(50% - 450px);
}
div.Modal > div.window.medium {
  width: 650px;
  left: calc(50% - 325px);
}
div.Modal > div.window.small {
  width: 400px;
  left: calc(50% - 200px);
}
div.Modal > div.window a.Button.close {
  top: 10px;
  right: 10px;
  position: absolute;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat;
  background-size: 20px;
  height: 20px;
  width: 20px;
  border: none;
  -webkit-box-shadow: none;
          box-shadow: none;
  color: #FFF;
  padding: 0;
  margin: 0;
  font-weight: 700;
  font-size: 13px;
  font-family: sans-serif;
  z-index: 1010;
  cursor: pointer;
}
div.Modal > div.window div.header {
  margin: 0;
  padding: 17px;
  background-color: #002E33;
  color: #FFF;
}
div.Modal > div.window div.header h1 {
  margin: 0;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.075em;
  line-height: 11px;
  text-align: center;
  text-transform: uppercase;
}
div.Modal > div.window div.content {
  left: 0;
  right: 0;
  padding: 24px 32px;
}
div.Modal > div.window div.content h1 {
  margin: 0;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.075em;
  color: #002E33;
  text-align: center;
  text-transform: uppercase;
}
div.Modal > div.window div.content p {
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  color: #697588;
  line-height: 18px;
  margin: 0px;
  padding-top: 14px;
}
div.Modal > div.window footer,
div.Modal > div.window div.footer {
  text-align: center;
  border-top: 1px solid #E8E9F0;
  padding: 24px 32px;
}
div.Modal > div.window footer .Button,
div.Modal > div.window div.footer .Button {
  line-height: 12px;
  padding: 11px 16px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}
div.Modal > div.window footer .Button:not(:first-child),
div.Modal > div.window div.footer .Button:not(:first-child) {
  margin-left: 15px;
}

.companyInformationModal div.content {
  height: 100%;
  overflow-y: scroll;
  padding: 0px !important;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.companyInformationModal footer {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  -webkit-box-shadow: 0 -1px 6px 0 #E8E9F0;
          box-shadow: 0 -1px 6px 0 #E8E9F0;
}
.companyInformationModal__tink {
  border: 1px solid #D92D20 !important;
  background-color: #FFF8F6;
}
.companyInformationModal__form {
  max-height: calc(100vh - 83px);
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  padding: 24px 0 0 32px;
  width: 720px;
  overflow-y: hidden;
}
@media screen and (max-width: 1220px) {
  .companyInformationModal__form {
    width: 600px;
  }
}
@media screen and (max-width: 920px) {
  .companyInformationModal__form {
    width: 100%;
    float: none;
  }
}
.companyInformationModal__form-closeIcon {
  color: #697588;
  cursor: pointer;
  float: right;
}
.companyInformationModal__form-closeIcon:hover {
  color: #002E33;
}
.companyInformationModal__form-addAnotherIBAN {
  margin-left: 224px;
}
.companyInformationModal__form-addAnotherIBANTink {
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  line-height: 1.5;
  display: block;
  margin-top: 0.5rem;
  margin-bottom: 18px;
  margin-left: 224px;
}
.companyInformationModal__form-addAnotherIBAN, .companyInformationModal__form-SetAsDefault {
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  line-height: 1.5;
  display: block;
  margin-top: 8px;
}
.companyInformationModal__form-addAnotherIBAN:hover, .companyInformationModal__form-SetAsDefault:hover {
  -webkit-text-decoration: underline;
  text-decoration: underline;
}
.companyInformationModal__form-addAnotherIBAN {
  margin-bottom: 18px;
}
.companyInformationModal__form .RadioButton {
  display: table !important;
}
.companyInformationModal__form-wrapper {
  padding-bottom: 32px;
}
.companyInformationModal__form-wrapper .fieldsWrapper {
  height: 110px;
}
.companyInformationModal__form-wrapper .fieldsWrapper-default {
  height: 96px;
}
.companyInformationModal__form-wrapper .ibanDuplicateError {
  color: #D92D20;
  margin-left: 225px;
  size: 12px;
  line-height: 16px;
  margin-bottom: 8px;
  display: block;
}
.companyInformationModal__form-wrapper .validationError {
  color: #D92D20;
  size: 12px;
  line-height: 16px;
  -ms-flex-item-align: center;
      align-self: center;
}
@media screen and (max-width: 1220px) {
  .companyInformationModal__form-wrapper .validationError {
    display: none;
  }
}
.companyInformationModal__form-wrapper .setAsDefaultIBAN {
  line-height: 16px;
  margin-bottom: 8px;
  display: block;
  margin-left: 14rem;
  margin-top: -8px;
}
.companyInformationModal__form-wrapper .withError {
  border: 1px solid #D92D20 !important;
  background-color: #FFF8F6;
}
.companyInformationModal__form-wrapper .OnlinePayment {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.companyInformationModal__form-wrapper .OnlinePayment__ibanToolTip {
  margin-left: 28rem;
  margin-top: -1.5rem;
}
.companyInformationModal__form-wrapper .OnlinePayment__label {
  font-size: 12px;
  font-weight: 500;
  color: #002E33;
  width: 225px;
  cursor: auto;
  margin-top: 12px;
}
.companyInformationModal__form-wrapper .OnlinePayment__connectButton {
  font-size: 12px;
  margin-left: 0.05rem;
  width: auto;
  max-width: 248px;
}
.companyInformationModal__form-wrapper .OnlinePayment__icons__cards {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
  background-size: 67px;
  height: 14px;
  margin-top: 12px;
}
.companyInformationModal__form-wrapper .OnlinePayment__icons__tink {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat;
  background-size: 30px;
  height: 18px;
  margin-top: 12px;
}
.companyInformationModal__form-wrapper .OnlinePayment__settings {
  font-size: 12px;
  font-weight: 500;
  color: #697588;
  max-width: 248px;
  cursor: auto;
}
.companyInformationModal__form-wrapper .OnlinePayment__settings a:hover {
  cursor: pointer;
}
.companyInformationModal__form-wrapper .OnlinePayment__settings .Controlled.CheckBox {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  padding-left: 0 !important;
  margin-top: 12px !important;
  height: auto;
}
.companyInformationModal__form-wrapper .OnlinePayment__settings .Controlled.CheckBox div.check {
  margin-top: 2px;
}
.companyInformationModal__form-wrapper .OnlinePayment__settings .Controlled.CheckBox span.Label {
  white-space: inherit;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
}
.companyInformationModal__form-wrapper .OnlinePayment__settings .Controlled.CheckBox span.Label span {
  line-height: 18px !important;
  color: #002E33;
}
.companyInformationModal__form-wrapper .OnlinePayment__settings .Controlled.CheckBox.disabled span.Label span {
  color: #697588;
}
.companyInformationModal__form-wrapper .OnlinePayment__settings__header {
  padding-top: 12px;
  color: #002E33;
}
.companyInformationModal__form-wrapper .OnlinePayment__settings__subLabel {
  line-height: 18px;
  padding-top: 8px;
  font-size: 12px;
}
.companyInformationModal__form-wrapper .OnlinePayment__settings__subLabel a {
  -webkit-text-decoration: none;
  text-decoration: none;
}
.companyInformationModal__form-wrapper .OnlinePayment__info {
  font-size: 12px;
  font-weight: 500;
  color: #002E33;
  max-width: 248px;
  cursor: auto;
}
.companyInformationModal__form-wrapper .OnlinePayment__info__body {
  padding-top: 12px;
  padding-bottom: 8px;
  line-height: 1.5;
  color: #697588;
}
.companyInformationModal__form-wrapper .OnlinePayment__info__body div.Button.link {
  margin-left: 0;
}
.companyInformationModal__preview {
  -webkit-box-flex: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
  max-height: calc(100vh - 83px);
  background: #F5F6F9;
  width: calc(100vw - 720px);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  overflow: hidden;
}
@media screen and (max-width: 920px) {
  .companyInformationModal__preview {
    width: 0%;
    float: none;
  }
  .companyInformationModal__preview iframe {
    display: none;
  }
}
.companyInformationModal__header {
  margin-left: 32px;
  margin-bottom: 32px;
  margin-top: 32px;
  font-size: 24px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.21;
  letter-spacing: normal;
  text-align: left;
  color: #002E33;
  display: block;
}
.companyInformationModal .zervant-tabs-content-wrap {
  height: calc(100% - 83px) !important;
  overflow-y: scroll !important;
  padding-right: 64px;
}
.companyInformationModal .zervant-tabs {
  padding: 8px 0 8px 32px;
  display: block;
  height: calc(100% - 55px);
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}
.companyInformationModal .zervant-tabs .zervant-tabs-switches {
  border-bottom: 1px solid #E8E9F0;
  margin-right: 64px;
}
.companyInformationModal .zervant-tabs .zervant-tabs-switches .zervant-tabs-switch {
  padding: 16px 0px 16px 0px;
  margin-right: 32px;
  -webkit-box-flex: initial;
      -ms-flex-positive: initial;
          flex-grow: initial;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #697588;
  cursor: pointer;
}
.companyInformationModal .zervant-tabs .zervant-tabs-switches .zervant-tabs-switch.active-tab {
  border-bottom: 1px solid #01FF94;
  color: #002E33;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content {
  margin-top: 32px;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .imageInputContainer {
  margin-left: 4px;
  width: 64px;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .imageInputContainer a {
  margin-left: 0 !important;
  display: inline-block !important;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .imageInputContainer .Clear {
  left: 280px !important;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .formLink {
  padding-left: 50%;
  margin-top: 16px;
  font-size: 12px;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .formLink a {
  color: #002E33;
  cursor: pointer;
  display: block;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .formLink span {
  padding-top: 16px;
  color: #697588;
  display: block;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .groupHeader {
  padding-left: 224px;
  font-weight: 900;
  color: #002E33;
  font-size: 10px;
  line-height: 1.2;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  margin-top: 32px;
  margin-bottom: 16px;
  position: relative;
  max-width: 255px;
}
@media only screen and (max-width: 600px) {
  .companyInformationModal .zervant-tabs .zervant-tabs-content .groupHeader {
    padding-left: 0px;
  }
}
.companyInformationModal .zervant-tabs .zervant-tabs-content div.search-select {
  margin: 0;
  height: auto;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content div.search-select div.Controlled.Input input {
  border-radius: 0px;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content div.search-select div.Controlled.Input span.Label {
  font-size: 12px;
  font-weight: 500;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content div.search-select__results {
  width: 254px !important;
  margin-left: 224px !important;
  margin-top: 0px;
}
@media only screen and (max-width: 600px) {
  .companyInformationModal .zervant-tabs .zervant-tabs-content div.search-select__results {
    margin-left: 0 !important;
    margin-left: initial !important;
    width: 100% !important;
  }
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .Controlled.autoFilled {
  background-color: #F5F6F9;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content div.Controlled.Input {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin: inherit;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content div.Controlled.Input input:disabled {
  border: none;
  color: #697588;
  background: #F5F6F9;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content div.Controlled.Input .countryField {
  background: none !important;
  color: #697588 !important;
}
@media only screen and (max-width: 600px) {
  .companyInformationModal .zervant-tabs .zervant-tabs-content div.Controlled.Input {
    height: auto;
    height: initial;
  }
}
.companyInformationModal .zervant-tabs .zervant-tabs-content div.Controlled.Input.CheckBox {
  margin-top: 24px;
  margin-bottom: 0px;
  margin-top: 8px;
  height: auto;
  padding-left: 224px;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content div.Controlled.Input.CheckBox > div.check {
  border-radius: 2px;
  margin-top: 0px;
  cursor: pointer;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content div.Controlled.Input.CheckBox > div.check.checked {
  background: #01FF94 url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  border: 1px solid #01FF94;
  background-size: 8px 6px;
  background-repeat: no-repeat;
  background-position: 2px 3px;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content div.Controlled.Input.CheckBox > span.Label {
  display: inline;
  position: inherit;
  color: #002E33;
  font-weight: 500;
  font-size: 12px;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content div.Controlled.Input.CheckBox.isNotVATLiable {
  margin-bottom: 8px !important;
  width: calc(100% - 224px);
}
.companyInformationModal .zervant-tabs .zervant-tabs-content div.Controlled.Input.CheckBox .Label {
  line-height: 14px !important;
  cursor: pointer;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content div.Controlled.Input.FilePreview {
  margin-bottom: 16px;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content div.Controlled.Input .Label {
  font-size: 12px;
  font-weight: 500;
  color: #002E33;
  width: 220px;
  padding-right: 0px;
  cursor: auto;
}
@media only screen and (max-width: 600px) {
  .companyInformationModal .zervant-tabs .zervant-tabs-content div.Controlled.Input .Label {
    position: static;
    position: initial;
    display: block;
  }
}
.companyInformationModal .zervant-tabs .zervant-tabs-content div.Controlled.Input input,
.companyInformationModal .zervant-tabs .zervant-tabs-content div.Controlled.Input div.select.Controlled {
  border-radius: 0px;
}
@media screen and (min-width: 600px) {
  .companyInformationModal .zervant-tabs .zervant-tabs-content div.Controlled.Input input,
  .companyInformationModal .zervant-tabs .zervant-tabs-content div.Controlled.Input div.select.Controlled {
    max-width: 255px;
    margin-left: 224px !important;
    margin-right: 14px;
  }
}
@media only screen and (max-width: 600px) {
  .companyInformationModal .zervant-tabs .zervant-tabs-content div.Controlled.Input input,
  .companyInformationModal .zervant-tabs .zervant-tabs-content div.Controlled.Input div.select.Controlled {
    max-width: 100%;
    margin-left: 0 !important;
    width: 100% !important;
    margin-bottom: 8px;
    height: 32px !important;
  }
}
.companyInformationModal .zervant-tabs .zervant-tabs-content div.Controlled.Input input .search input,
.companyInformationModal .zervant-tabs .zervant-tabs-content div.Controlled.Input div.select.Controlled .search input {
  margin-left: 0px !important;
  background: transparent;
  border: 1px solid #D3D6DF;
  padding: 5px;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content div.Controlled.Input div.selected-value {
  border-radius: 0px;
  max-width: 255px;
}
@media only screen and (max-width: 600px) {
  .companyInformationModal .zervant-tabs .zervant-tabs-content div.Controlled.Input div.selected-value {
    max-width: 100%;
  }
}
.companyInformationModal .zervant-tabs .zervant-tabs-content div.Controlled.Input.CustomTemplate {
  margin: 5mm 0 5mm 0;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .Label {
  color: #002E33;
  font-size: 12px;
  font-weight: 500;
  width: 190px;
}
@media only screen and (max-width: 600px) {
  .companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .Label {
    position: static;
    position: initial;
    display: block;
  }
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .CustomTemplate {
  margin: 5mm 0 5mm 0;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .BoxContainer {
  display: inline-block;
}
@media screen and (min-width: 600px) {
  .companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .BoxContainer {
    max-width: 265px;
    margin-left: 224px !important;
  }
}
@media only screen and (max-width: 600px) {
  .companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .BoxContainer {
    max-width: 100%;
    margin-left: 0 !important;
    width: 100% !important;
    margin-bottom: 8px;
    height: 32px !important;
  }
}
@media screen and (max-width: 1220px) and (min-width: 600px) {
  .companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .BoxContainer {
    max-width: 265px;
    margin-left: 224px !important;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
  }
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .Box {
  display: inline-block;
  margin: 0 2mm 0 0;
  border: 1px solid #E8E9F0;
  border-radius: 4px;
  cursor: pointer;
  height: 35px;
  width: 77px;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .Box__1 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center 12px;
  background-size: 45px;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .Box__2 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat center 8px;
  background-size: 45px;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .Box__3 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat center 8px;
  background-size: 45px;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .Box__Active {
  background-color: #F5F6F9;
}
@media screen and (max-width: 1220px) {
  .companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .Box {
    margin-bottom: 10px;
  }
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .CustomPremium {
  margin: 8mm 0 5mm 0;
}
@media screen and (max-width: 1220px) and (min-width: 600px) {
  .companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .CustomPremium {
    margin-top: 120px;
  }
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .CustomPremium .Label {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .CustomPremium .Label img {
  margin-left: 7px;
  width: 12px;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .PremiumToggle {
  display: inline-block;
}
@media screen and (min-width: 600px) {
  .companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .PremiumToggle {
    max-width: 265px;
    margin-left: 224px !important;
  }
}
@media only screen and (max-width: 600px) {
  .companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .PremiumToggle {
    max-width: 100%;
    margin-left: 0 !important;
    width: 100% !important;
    height: 32px !important;
  }
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .PremiumToggle .PremiumText {
  color: #697588;
  font-size: 12px;
  line-height: 15pt;
  text-align: left;
}
@media only screen and (max-width: 600px) {
  .companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .PremiumToggle .PremiumText {
    max-width: 100%;
    margin-left: 0 !important;
    width: 100% !important;
    text-align: left;
  }
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .ColorPicker {
  display: inline-block;
}
@media screen and (min-width: 600px) {
  .companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .ColorPicker {
    max-width: 265px;
    margin-left: 224px !important;
  }
}
@media only screen and (max-width: 600px) {
  .companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .ColorPicker {
    max-width: 100%;
    margin-left: 0 !important;
    width: 100% !important;
    height: 32px !important;
  }
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .ColorPicker p {
  display: inline-block;
  padding-top: 0;
  padding-left: 10px;
  line-height: 32px;
  height: 100%;
  position: absolute;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .ColorPicker__selected {
  width: 29px;
  height: 29px;
  border-radius: 2px;
  padding-top: 2px;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .ColorPicker__swatch {
  border-radius: 1px;
  -webkit-box-shadow: 0 0 0 1px #E8E9F0;
          box-shadow: 0 0 0 1px #E8E9F0;
  display: inline-block;
  cursor: pointer;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .ColorPicker__popover {
  position: absolute;
  z-index: 2;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .ColorPicker__popover .ColorContainer:before {
  content: "";
  background: #FFF;
  width: 15px;
  height: 15px;
  -webkit-transform: rotate(-45deg);
          transform: rotate(-45deg);
  position: absolute;
  -webkit-box-shadow: 1px 4px 8px rgba(0, 0, 0, 0.5);
          box-shadow: 1px 4px 8px rgba(0, 0, 0, 0.5);
  z-index: 3;
  top: -7px;
  left: 7px;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .ColorPicker__popover .ColorContainer {
  position: relative;
  background: none;
  -webkit-box-shadow: 1px 1px 12px #697588;
          box-shadow: 1px 1px 12px #697588;
  border-radius: 2px;
  z-index: 2;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .ColorPicker__popover .ColorContainer .InnerColorBox {
  position: relative;
  background: #FFF;
  z-index: 4;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .ColorPicker__popover .ColorContainer .ColorBox {
  padding: 8px 8px 20px 16px;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .ColorPicker__popover input {
  float: none !important;
  margin-left: 0px !important;
  border-radius: 2px;
  border: solid 1px #E8E9F0;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .ColorPicker__cover {
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .poppins {
  font-family: "Poppins", sans-serif;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .roboto {
  font-family: "Roboto", sans-serif;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .robotoMono {
  font-family: "Roboto Mono", monospace;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .workSans {
  font-family: "Work Sans", sans-serif;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .playfair {
  font-family: "Playfair Display", serif;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .Quicksand {
  font-family: "Quicksand", sans-serif;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .libreBaskerville {
  font-family: "Libre Baskerville", serif;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .bitter {
  font-family: "Bitter", serif;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .varelaRound {
  font-family: "Varela Round", sans-serif;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .zillaSlab {
  font-family: "Zilla Slab", serif;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .volkhov {
  font-family: "Volkhov", serif;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .georama {
  font-family: "Georama", sans-serif;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .baskervville {
  font-family: "Baskervville", serif;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .arvo {
  font-family: "Arvo", serif;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .spaceMono {
  font-family: "Space Mono", monospace;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .rokkitt {
  font-family: "Rokkitt", serif;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .sen {
  font-family: "Sen", sans-serif;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .krub {
  font-family: "Krub", sans-serif;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .fahkwang {
  font-family: "Fahkwang", sans-serif;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .solway {
  font-family: "Solway", serif;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .robotoCondensed {
  font-family: "Roboto Condensed", sans-serif;
}
.companyInformationModal .zervant-tabs .zervant-tabs-content .InvoiceTemplateForm .ibmPlexSansCondensed {
  font-family: "IBM Plex Sans Condensed", sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/client/components/common/Modal/Modal.scss","webpack://./src/client/components/Modal/CompanyInformationModal/CompanyInformationModal.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAEA;EACE,SAAA;EACA,QAAA;EACA,mCAAA;UAAA,2BAAA;ACAF;;ADkGE;EACE,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,wCAAA;EACA,aAAA;AC/FJ;ADkGE;EAvGA,SAAA;EACA,QAAA;EACA,mCAAA;UAAA,2BAAA;EA0HE,sBE9HI;EF+HJ,eAAA;EACA,6BAAA;EACA,WAAA;EACA,uCAAA;UAAA,+BAAA;EACA,cAAA;EACA,aAAA;ACjHJ;ADyFI;EACE,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,2BAAA;ACvFN;ADyFM;EACE,aAAA;ACvFR;AD0FM;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,gBE1HA;ADkCR;ADoGI;EACE,aAAA;EACA,yBAAA;AClGN;ADqGI;EACE,YAAA;EACA,uBAAA;ACnGN;ADsGI;EACE,YAAA;EACA,uBAAA;ACpGN;ADuGI;EACE,YAAA;EACA,uBAAA;ACrGN;ADwGI;EACE,SAAA;EACA,WAAA;EACA,kBAAA;EACA,2EAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;UAAA,gBAAA;EACA,WEpKE;EFqKF,UAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;ACtGN;ADyGI;EAtKF,SAAA;EACA,aAAA;EACA,yBEhBa;EFiBb,WEXM;AD2ER;AD9DE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;ACgEJ;AD8FI;EAzJF,OAAA;EACA,QAAA;EACA,kBAAA;AC8DF;AD5DE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,cExCW;EFyCX,kBAAA;EACA,yBAAA;AC8DJ;AD3DE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cEEK;EFDL,iBAAA;EACA,WAAA;EACA,iBAAA;AC6DJ;AD2EI;;EAnIF,kBAAA;EACA,6BAAA;EACA,kBAAA;AC4DF;AD1DE;;EACE,iBAAA;EACA,kBAAA;EACA,0BAAA;EAAA,uBAAA;EAAA,kBAAA;AC6DJ;AD3DI;;EACE,iBAAA;AC8DN;;AA5HE;EACE,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;AA+HJ;AA5HE;EACE,8BAAA;UAAA,sBAAA;EACA,wCAAA;UAAA,gCAAA;AA8HJ;AA3HE;EACE,oCAAA;EACA,yBC4BG;ADiGP;AA1HE;EACE,8BAAA;EACA,8BAAA;UAAA,sBAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AA4HJ;AA1HI;EAPF;IAQI,YAAA;EA6HJ;AACF;AA3HI;EAXF;IAYI,WAAA;IACA,WAAA;EA8HJ;AACF;AA5HI;EACE,cCYG;EDXH,eAAA;EACA,YAAA;AA8HN;AA5HM;EACE,cC5CO;AD0Kf;AA1HI;EACE,kBAAA;AA4HN;AAzHI;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AA2HN;AAxHI;EAEE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAyHN;AAvHM;EACE,kCAAA;EAAA,0BAAA;AAyHR;AArHI;EACE,mBAAA;AAuHN;AApHI;EACE,yBAAA;AAsHN;AAlHE;EACE,oBAAA;AAoHJ;AAlHI;EACE,aAAA;AAoHN;AAlHM;EACE,YAAA;AAoHR;AAhHI;EACE,cCzFA;ED0FA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAkHN;AA/GI;EACE,cClGA;EDmGA,UAAA;EACA,iBAAA;EACA,2BAAA;MAAA,kBAAA;AAiHN;AAhHM;EALF;IAMI,aAAA;EAmHN;AACF;AAhHI;EACE,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAkHN;AA/GI;EACE,oCAAA;EACA,yBC/EC;ADgMP;AA9GI;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;AAgHN;AA9GK;EACC,kBAAA;EACA,mBAAA;AAgHN;AA7GM;EACE,eAAA;EACA,gBAAA;EACA,cC5IO;ED6IP,YAAA;EACA,YAAA;EACA,gBAAA;AA+GR;AA7GM;EACE,eAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;AA+GR;AA3GQ;EACE,6DAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;AA6GV;AA3GQ;EACE,6DAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;AA6GV;AAzGM;EACE,eAAA;EACA,gBAAA;EACA,cCvHC;EDwHD,gBAAA;EACA,YAAA;AA2GR;AAzGQ;EACE,eAAA;AA2GV;AAxGQ;EACE,+BAAA;EAAA,+BAAA;EAAA,wBAAA;EACA,0BAAA;EACA,2BAAA;EACA,YAAA;AA0GV;AAzGU;EACE,eAAA;AA2GZ;AAzGU;EACE,oBAAA;EACA,2BAAA;EAAA,wBAAA;EAAA,mBAAA;AA2GZ;AA1GY;EACE,4BAAA;EACA,cC/LC;AD2Sf;AAvGc;EACE,cClJP;AD2PT;AApGQ;EACE,iBAAA;EACA,cC5MK;ADkTf;AApGQ;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;AAsGV;AArGU;EACE,6BAAA;EAAA,qBAAA;AAuGZ;AAlGM;EACE,eAAA;EACA,gBAAA;EACA,cC3NO;ED4NP,gBAAA;EACA,YAAA;AAoGR;AAlGQ;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cChLD;ADoRT;AAnGU;EACE,cAAA;AAqGZ;AA9FE;EACE,mBAAA;MAAA,oBAAA;UAAA,YAAA;EACA,8BAAA;EACA,mBCvLK;EDwLL,0BAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,gBAAA;AAgGJ;AA9FI;EAVF;IAWI,SAAA;IACA,WAAA;EAiGJ;EA/FI;IACE,aAAA;EAiGN;AACF;AA7FE;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cC3QW;ED4QX,cAAA;AA+FJ;AA5FE;EACE,oCAAA;EACA,6BAAA;EACA,mBAAA;AA8FJ;AA3FE;EACE,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,8BAAA;UAAA,sBAAA;AA6FJ;AA3FI;EACE,gCAAA;EACA,kBAAA;AA6FN;AA3FM;EACE,0BAAA;EACA,kBAAA;EACA,yBAAA;MAAA,0BAAA;UAAA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cCtPC;EDuPD,eAAA;AA6FR;AA3FQ;EACE,gCAAA;EACA,cC9SK;AD2Yf;AAxFI;EACE,gBAAA;AA0FN;AAxFM;EACE,gBAAA;EACA,WAAA;AA0FR;AAxFQ;EACE,yBAAA;EACA,gCAAA;AA0FV;AAvFQ;EACE,sBAAA;AAyFV;AArFM;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;AAuFR;AArFQ;EACE,cC1UK;ED2UL,eAAA;EACA,cAAA;AAuFV;AApFQ;EACE,iBAAA;EACA,cC9RD;ED+RC,cAAA;AAsFV;AAlFM;EACE,mBAAA;EACA,gBAAA;EACA,cCzVO;ED0VP,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAoFR;AAjFQ;EAdF;IAeI,iBAAA;EAoFR;AACF;AAjFM;EACE,SAAA;EACA,YAAA;AAmFR;AAhFU;EACE,kBAAA;AAkFZ;AA/EU;EACE,eAAA;EACA,gBAAA;AAiFZ;AA7EQ;EACE,uBAAA;EACA,6BAAA;EACA,eAAA;AA+EV;AA7EU;EALF;IAMI,yBAAA;IAAA,+BAAA;IACA,sBAAA;EAgFV;AACF;AA5EM;EACE,yBC7UC;AD2ZT;AA3EM;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EAiCA,eAAA;AA6CR;AA5EQ;EACE,YAAA;EACA,cC1VD;ED2VC,mBCtVD;ADoaT;AA3EQ;EACE,2BAAA;EACA,yBAAA;AA6EV;AA1EQ;EAdF;IAeI,YAAA;IAAA,eAAA;EA6ER;AACF;AA3EQ;EDjVN,gBAAA;EACA,kBAAA;ECkVQ,eAAA;EACA,YAAA;EACA,mBAAA;AA8EV;ADhaE;EACE,kBAAA;EACA,eAAA;EACA,eAAA;ACkaJ;AD/ZE;EACE,2DAAA;EACA,yBAAA;EACA,wBAAA;EACA,4BAAA;EACA,4BAAA;ACiaJ;AD9ZE;EACE,eAAA;EACA,iBAAA;EACA,cE7FW;EF8FX,gBAAA;EACA,eAAA;ACgaJ;AAhGU;EACE,6BAAA;EACA,yBAAA;AAkGZ;AA/FU;EACE,4BAAA;EACA,eAAA;AAiGZ;AA3FQ;EACE,mBAAA;AA6FV;AA1FQ;EACE,eAAA;EACA,gBAAA;EACA,cCnbK;EDobL,YAAA;EACA,kBAAA;EACA,YAAA;AA4FV;AA1FU;EARF;IASI,gBAAA;IAAA,iBAAA;IACA,cAAA;EA6FV;AACF;AA1FQ;;EAEE,kBAAA;AA4FV;AA1FU;EAJF;;IAKI,gBAAA;IACA,6BAAA;IACA,kBAAA;EA8FV;AACF;AA5FU;EAVF;;IAWI,eAAA;IACA,yBAAA;IACA,sBAAA;IACA,kBAAA;IACA,uBAAA;EAgGV;AACF;AA7FY;;EACE,2BAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AAgGd;AA3FQ;EACE,kBAAA;EACA,gBAAA;AA6FV;AA3FU;EAJF;IAKI,eAAA;EA8FV;AACF;AA3FQ;EACE,mBAAA;AA6FV;AAxFQ;EACE,cC1eK;ED2eL,eAAA;EACA,gBAAA;EACA,YAAA;AA0FV;AAxFU;EANF;IAOI,gBAAA;IAAA,iBAAA;IACA,cAAA;EA2FV;AACF;AAzFQ;EACE,mBAAA;AA2FV;AAzFQ;EACE,qBAAA;AA2FV;AAzFU;EAHF;IAII,gBAAA;IACA,6BAAA;EA4FV;AACF;AA1FU;EARF;IASI,eAAA;IACA,yBAAA;IACA,sBAAA;IACA,kBAAA;IACA,uBAAA;EA6FV;AACF;AA3FU;EAhBF;IAiBI,gBAAA;IACA,6BAAA;IACA,oBAAA;IAAA,oBAAA;IAAA,aAAA;IACA,4BAAA;IAAA,6BAAA;QAAA,0BAAA;YAAA,sBAAA;EA8FV;AACF;AA5FQ;EACE,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AA8FV;AA7FU;EACE,yEAAA;EACA,qBAAA;AA+FZ;AA7FU;EACE,wEAAA;EACA,qBAAA;AA+FZ;AA7FU;EACE,wEAAA;EACA,qBAAA;AA+FZ;AA7FU;EACE,yBC3eH;AD0kBT;AA7FU;EAvBF;IAwBI,mBAAA;EAgGV;AACF;AA9FQ;EACE,mBAAA;AAgGV;AA9FU;EAHF;IAII,iBAAA;EAiGV;AACF;AA/FU;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;AAiGZ;AA/FY;EACE,gBAAA;EACA,WAAA;AAiGd;AA7FQ;EACE,qBAAA;AA+FV;AA7FU;EAHF;IAII,gBAAA;IACA,6BAAA;EAgGV;AACF;AA9FU;EARF;IASI,eAAA;IACA,yBAAA;IACA,sBAAA;IACA,uBAAA;EAiGV;AACF;AA/FU;EACE,cCvhBH;EDwhBG,eAAA;EACA,iBAAA;EACA,gBAAA;AAiGZ;AA/FY;EANF;IAOI,eAAA;IACA,yBAAA;IACA,sBAAA;IACA,gBAAA;EAkGZ;AACF;AA/FQ;EACE,qBAAA;AAiGV;AA/FU;EAHF;IAII,gBAAA;IACA,6BAAA;EAkGV;AACF;AAhGU;EARF;IASI,eAAA;IACA,yBAAA;IACA,sBAAA;IACA,uBAAA;EAmGV;AACF;AAjGU;EACE,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AAmGZ;AAjGU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAmGZ;AAjGU;EACE,kBAAA;EACA,qCAAA;UAAA,6BAAA;EACA,qBAAA;EACA,eAAA;AAmGZ;AAjGU;EACE,kBAAA;EACA,UAAA;AAmGZ;AAjGY;EACE,WAAA;EACA,gBC1nBN;ED2nBM,WAAA;EACA,YAAA;EACA,iCAAA;UAAA,yBAAA;EACA,kBAAA;EACA,kDAAA;UAAA,0CAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AAmGd;AAhGY;EACE,kBAAA;EACA,gBAAA;EACA,wCAAA;UAAA,gCAAA;EACA,kBAAA;EACA,UAAA;AAkGd;AAhGc;EACE,kBAAA;EACA,gBC9oBR;ED+oBQ,UAAA;AAkGhB;AA/Fc;EACE,0BAAA;AAiGhB;AA7FY;EACE,sBAAA;EACA,2BAAA;EACA,kBAAA;EACA,yBAAA;AA+Fd;AA3FU;EACE,eAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;AA6FZ;AA1FQ;EACE,kCAAA;AA4FV;AA1FQ;EACE,iCAAA;AA4FV;AA1FQ;EACE,qCAAA;AA4FV;AA1FQ;EACE,oCAAA;AA4FV;AA1FQ;EACE,sCAAA;AA4FV;AA1FQ;EACE,oCAAA;AA4FV;AA1FQ;EACE,uCAAA;AA4FV;AA1FQ;EACE,4BAAA;AA4FV;AA1FQ;EACE,uCAAA;AA4FV;AA1FQ;EACE,gCAAA;AA4FV;AA1FQ;EACE,6BAAA;AA4FV;AA1FQ;EACE,kCAAA;AA4FV;AA1FQ;EACE,kCAAA;AA4FV;AA1FQ;EACE,0BAAA;AA4FV;AA1FQ;EACE,oCAAA;AA4FV;AA1FQ;EACE,6BAAA;AA4FV;AA1FQ;EACE,8BAAA;AA4FV;AA1FQ;EACE,+BAAA;AA4FV;AA1FQ;EACE,mCAAA;AA4FV;AA1FQ;EACE,4BAAA;AA4FV;AA1FQ;EACE,2CAAA;AA4FV;AA1FQ;EACE,kDAAA;AA4FV","sourcesContent":["@import \"../../../Global/Colors.scss\";\n\ndiv.Modal>div.window {\n  border: 0;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n\n@mixin modalWindowRules {\n  border: 0;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n@mixin headerRules {\n  margin: 0;\n  padding: 17px;\n  background-color: $DeepSeaGreen;\n  color: $White;\n\n  h1 {\n    margin: 0;\n    font-size: 11px;\n    font-weight: 900;\n    letter-spacing: 0.075em;\n    line-height: 11px;\n    text-align: center;\n    text-transform: uppercase;\n  }\n}\n\n@mixin contentRules {\n  left: 0;\n  right: 0;\n  padding: 24px 32px;\n\n  h1 {\n    margin: 0;\n    font-size: 11px;\n    font-weight: 900;\n    letter-spacing: 0.075em;\n    color: $DeepSeaGreen;\n    text-align: center;\n    text-transform: uppercase;\n  }\n\n  p {\n    text-align: center;\n    font-size: 12px;\n    font-weight: 500;\n    color: $Gray90;\n    line-height: 18px;\n    margin: 0px;\n    padding-top: 14px;\n  }\n}\n\n@mixin footerRules {\n  text-align: center;\n  border-top: 1px solid $Gray30;\n  padding: 24px 32px;\n\n  .Button {\n    line-height: 12px;\n    padding: 11px 16px;\n    width: fit-content;\n\n    &:not(:first-child) {\n      margin-left: 15px;\n    }\n  }\n}\n\n@mixin checkboxRules {\n  margin-top: 24px;\n  margin-bottom: 0px;\n\n  >div.check {\n    border-radius: 2px;\n    margin-top: 0px;\n    cursor: pointer;\n  }\n\n  >div.check.checked {\n    background: $ElectricGreen url(\"~images/checkmark_deepSeaGreen.svg\");\n    border: 1px solid $ElectricGreen;\n    background-size: 8px 6px;\n    background-repeat: no-repeat;\n    background-position: 2px 3px;\n  }\n\n  >span.Label {\n    display: inline;\n    position: inherit;\n    color: $DeepSeaGreen;\n    font-weight: 500;\n    font-size: 12px;\n  }\n}\n\ndiv.Modal {\n\n  >div.overlay {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-color: rgba($Gray200, 0.75);\n    z-index: 3000;\n  }\n\n  >div.window {\n    @include modalWindowRules;\n\n    &.fullscreen {\n      width: 100% !important;\n      left: 0 !important;\n      height: 100% !important;\n      max-height: 100% !important;\n\n      content {\n        height: calc(100vh);\n      }\n\n      footer {\n        position: fixed;\n        bottom: 0;\n        width: 100%;\n        background: $White;\n      }\n    }\n\n    background-color: $White;\n    position: fixed;\n    max-height: calc(100% - 20px);\n    right: auto;\n    box-shadow: 2px 2px 5px $shadowColor;\n    overflow: auto;\n    z-index: 3001;\n\n    &.extra-wide {\n      width: 1167px;\n      left: calc(50% - 583.5px);\n    }\n\n    &.wide {\n      width: 900px;\n      left: calc(50% - 450px);\n    }\n\n    &.medium {\n      width: 650px;\n      left: calc(50% - 325px);\n    }\n\n    &.small {\n      width: 400px;\n      left: calc(50% - 200px);\n    }\n\n    a.Button.close {\n      top: 10px;\n      right: 10px;\n      position: absolute;\n      background: url(\"~images/close_modal_White.svg\") center center no-repeat;\n      background-size: 20px;\n      height: 20px;\n      width: 20px;\n      border: none;\n      box-shadow: none;\n      color: $White;\n      padding: 0;\n      margin: 0;\n      font-weight: 700;\n      font-size: 13px;\n      font-family: sans-serif;\n      z-index: 1010;\n      cursor: pointer;\n    }\n\n    div.header {\n      @include headerRules;\n    }\n\n    div.content {\n      @include contentRules;\n    }\n\n    footer,\n    div.footer {\n      @include footerRules;\n    }\n  }\n\n}\n","@import \"../../../Global/Colors.scss\";\n@import \"../../../components/common/Modal/Modal\";\n@import url('https://fonts.googleapis.com/css2?family=Arvo&family=Baskervville&family=Bitter&family=Fahkwang&family=Georama&family=IBM+Plex+Sans+Condensed&family=Krub&family=Libre+Baskerville&family=Open+Sans&family=Playfair+Display&family=Poppins&family=Quicksand&family=Roboto&family=Roboto+Condensed&family=Roboto+Mono&family=Rokkitt&family=Sen&family=Solway&family=Space+Mono&family=Varela+Round&family=Volkhov&family=Work+Sans&family=Zilla+Slab&display=swap');\n\n$mobileWidth: 600px;\n\n.companyInformationModal {\n  div.content {\n    height: 100%;\n    overflow-y: scroll;\n    padding: 0px !important;\n    display: flex;\n  }\n\n  footer {\n    box-sizing: border-box;\n    box-shadow: 0 -1px 6px 0 $Gray30;\n  }\n\n  &__tink {\n    border: 1px solid $Red !important;\n    background-color: $Red5;\n  }\n\n  &__form {\n    max-height: calc(100vh - 83px);\n    box-sizing: border-box;\n    padding: 24px 0 0 32px;\n    width: 720px;\n    overflow-y: hidden;\n\n    @media screen and (max-width: 1220px) {\n      width: 600px;\n    }\n\n    @media screen and (max-width: 920px) {\n      width: 100%;\n      float: none;\n    }\n\n    &-closeIcon {\n      color: $Gray90;\n      cursor: pointer;\n      float: right;\n\n      &:hover {\n        color: $DeepSeaGreen;\n      }\n    }\n\n    &-addAnotherIBAN {\n      margin-left: 224px;\n    }\n\n    &-addAnotherIBANTink {\n      font-size: 12px;\n      font-weight: 600;\n      cursor: pointer;\n      line-height: 1.5;\n      display: block;\n      margin-top: 0.5rem;\n      margin-bottom: 18px;\n      margin-left: 224px;\n    }\n\n    &-addAnotherIBAN,\n    &-SetAsDefault {\n      font-size: 12px;\n      font-weight: 600;\n      cursor: pointer;\n      line-height: 1.5;\n      display: block;\n      margin-top: 8px;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n\n    &-addAnotherIBAN {\n      margin-bottom: 18px;\n    }\n\n    .RadioButton {\n      display: table !important;\n    }\n  }\n\n  &__form-wrapper {\n    padding-bottom: 32px;\n\n    .fieldsWrapper {\n      height: 110px;\n\n      &-default {\n        height: 96px;\n      }\n    }\n\n    .ibanDuplicateError {\n      color: $Red;\n      margin-left: 225px;\n      size: 12px;\n      line-height: 16px;\n      margin-bottom: 8px;\n      display: block;\n    }\n\n    .validationError {\n      color: $Red;\n      size: 12px;\n      line-height: 16px;\n      align-self: center;\n      @media screen and (max-width: 1220px) {\n        display: none;\n      }\n    }\n\n    .setAsDefaultIBAN {\n      line-height: 16px;\n      margin-bottom: 8px;\n      display: block;\n      margin-left: 14rem;\n      margin-top: -8px;\n    }\n\n    .withError {\n      border: 1px solid $Red !important;\n      background-color: $Red5;\n    }\n\n    .OnlinePayment {\n      display: flex;\n\n     &__ibanToolTip {\n      margin-left: 28rem;\n      margin-top: -1.5rem;\n    }\n\n      &__label {\n        font-size: 12px;\n        font-weight: 500;\n        color: $DeepSeaGreen;\n        width: 225px;\n        cursor: auto;\n        margin-top: 12px;\n      }\n      &__connectButton {\n        font-size: 12px;\n        margin-left: 0.05rem;\n        width: auto;\n        max-width: 248px;\n      }\n\n      &__icons {\n        &__cards {\n          background: url(~images/stripe_supported_cards.svg) no-repeat;\n          background-size: 67px;\n          height: 14px;\n          margin-top: 12px;\n        }\n        &__tink {\n          background: url(~images/tink_payments_icon2.svg) no-repeat;\n          background-size: 30px;\n          height: 18px;\n          margin-top: 12px;\n        }\n      }\n\n      &__settings {\n        font-size: 12px;\n        font-weight: 500;\n        color: $Gray90;\n        max-width: 248px;\n        cursor: auto;\n\n        a:hover {\n          cursor: pointer;\n        }\n\n        .Controlled.CheckBox {\n          display: flex !important;\n          padding-left: 0 !important;\n          margin-top: 12px !important;\n          height: auto;\n          div.check {\n            margin-top: 2px;\n          }\n          span.Label {\n            white-space: unset;\n            height: fit-content;\n            span {\n              line-height: 18px !important;\n              color: $DeepSeaGreen;\n            }\n          }\n          &.disabled {\n            span.Label {\n              span {\n                color: $Gray90;\n              }\n            }\n          }\n        }\n        &__header {\n          padding-top: 12px;\n          color: $DeepSeaGreen;\n        }\n        &__subLabel {\n          line-height: 18px;\n          padding-top: 8px;\n          font-size: 12px;\n          a {\n            text-decoration: none;\n          }\n        }\n      }\n\n      &__info {\n        font-size: 12px;\n        font-weight: 500;\n        color: $DeepSeaGreen;\n        max-width: 248px;\n        cursor: auto;\n\n        &__body {\n          padding-top: 12px;\n          padding-bottom: 8px;\n          line-height: 1.5;\n          color: $Gray90;\n          div.Button.link {\n            margin-left: 0;\n          }\n        }\n      }\n    }\n  }\n\n  &__preview {\n    flex-grow: 1;\n    max-height: calc(100vh - 83px);\n    background: $Gray20;\n    width: calc(100vw - 720px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n\n    @media screen and (max-width: 920px) {\n      width: 0%;\n      float: none;\n\n      iframe {\n        display: none;\n      }\n    }\n  }\n\n  &__header {\n    margin-left: 32px;\n    margin-bottom: 32px;\n    margin-top: 32px;\n    font-size: 24px;\n    font-weight: bold;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: 1.21;\n    letter-spacing: normal;\n    text-align: left;\n    color: $DeepSeaGreen;\n    display: block;\n  }\n\n  .zervant-tabs-content-wrap {\n    height: calc(100% - 83px) !important;\n    overflow-y: scroll !important;\n    padding-right: 64px;\n  }\n\n  .zervant-tabs {\n    padding: 8px 0 8px 32px;\n    display: block;\n    height: calc(100% - 55px);\n    box-sizing: border-box;\n\n    .zervant-tabs-switches {\n      border-bottom: 1px solid $Gray30;\n      margin-right: 64px;\n\n      .zervant-tabs-switch {\n        padding: 16px 0px 16px 0px;\n        margin-right: 32px;\n        flex-grow: initial;\n        font-size: 14px;\n        font-weight: 500;\n        font-style: normal;\n        font-stretch: normal;\n        line-height: 1.29;\n        letter-spacing: normal;\n        color: $Gray90;\n        cursor: pointer;\n\n        &.active-tab {\n          border-bottom: 1px solid $ElectricGreen;\n          color: $DeepSeaGreen;\n        }\n      }\n    }\n\n    .zervant-tabs-content {\n      margin-top: 32px;\n\n      .imageInputContainer {\n        margin-left: 4px;\n        width: 64px;\n\n        a {\n          margin-left: 0 !important;\n          display: inline-block !important;\n        }\n\n        .Clear {\n          left: 280px !important;\n        }\n      }\n\n      .formLink {\n        padding-left: 50%;\n        margin-top: 16px;\n        font-size: 12px;\n\n        a {\n          color: $DeepSeaGreen;\n          cursor: pointer;\n          display: block;\n        }\n\n        span {\n          padding-top: 16px;\n          color: $Gray90;\n          display: block;\n        }\n      }\n\n      .groupHeader {\n        padding-left: 224px;\n        font-weight: 900;\n        color: $DeepSeaGreen;\n        font-size: 10px;\n        line-height: 1.2;\n        letter-spacing: 0.8px;\n        text-transform: uppercase;\n        margin-top: 32px;\n        margin-bottom: 16px;\n        position: relative;\n        max-width: 255px;\n\n\n        @media only screen and (max-width: $mobileWidth) {\n          padding-left: 0px;\n        }\n      }\n\n      div.search-select {\n        margin: 0;\n        height: auto;\n\n        div.Controlled.Input {\n          input {\n            border-radius: 0px;\n          }\n\n          span.Label {\n            font-size: 12px;\n            font-weight: 500;\n          }\n        }\n\n        &__results {\n          width: 254px !important;\n          margin-left: 224px !important;\n          margin-top: 0px;\n\n          @media only screen and (max-width: $mobileWidth) {\n            margin-left: initial !important;\n            width: 100% !important;\n          }\n        }\n      }\n\n      .Controlled.autoFilled {\n        background-color: $Gray20;\n      }\n\n      div.Controlled.Input {\n        display: flex;\n\n        input:disabled {\n          border: none;\n          color: $Gray90;\n          background: $Gray20;\n        }\n\n        .countryField {\n          background: none !important;\n          color: $Gray90 !important;\n        }\n\n        @media only screen and (max-width: $mobileWidth) {\n          height: initial;\n        }\n\n        &.CheckBox {\n          @include checkboxRules;\n          margin-top: 8px;\n          height: auto;\n          padding-left: 224px;\n          &.isNotVATLiable {\n            margin-bottom: 8px !important;\n            width: calc(100% - 224px);\n          }\n\n          .Label {\n            line-height: 14px !important;\n            cursor: pointer;\n          }\n        }\n\n        margin: inherit;\n\n        &.FilePreview {\n          margin-bottom: 16px;\n        }\n\n        .Label {\n          font-size: 12px;\n          font-weight: 500;\n          color: $DeepSeaGreen;\n          width: 220px;\n          padding-right: 0px;\n          cursor: auto;\n\n          @media only screen and (max-width: $mobileWidth) {\n            position: initial;\n            display: block;\n          }\n        }\n\n        input,\n        div.select.Controlled {\n          border-radius: 0px;\n\n          @media screen and (min-width: $mobileWidth) {\n            max-width: 255px;\n            margin-left: 224px !important;\n            margin-right: 14px;\n          }\n\n          @media only screen and (max-width: $mobileWidth) {\n            max-width: 100%;\n            margin-left: 0 !important;\n            width: 100% !important;\n            margin-bottom: 8px;\n            height: 32px !important;\n          }\n\n          .search {\n            input {\n              margin-left: 0px !important;\n              background: transparent;\n              border: 1px solid $Gray50;\n              padding: 5px;\n            }\n          }\n        }\n\n        div.selected-value {\n          border-radius: 0px;\n          max-width: 255px;\n\n          @media only screen and (max-width: $mobileWidth) {\n            max-width: 100%;\n          }\n        }\n\n        &.CustomTemplate {\n          margin: 5mm 0 5mm 0;\n        }\n      }\n\n      .InvoiceTemplateForm {\n        .Label {\n          color: $DeepSeaGreen;\n          font-size: 12px;\n          font-weight: 500;\n          width: 190px;\n\n          @media only screen and (max-width: $mobileWidth) {\n            position: initial;\n            display: block;\n          }\n        }\n        .CustomTemplate {\n          margin: 5mm 0 5mm 0;\n        }\n        .BoxContainer {\n          display: inline-block;\n\n          @media screen and (min-width: $mobileWidth) {\n            max-width: 265px;\n            margin-left: 224px !important;\n          }\n\n          @media only screen and (max-width: $mobileWidth) {\n            max-width: 100%;\n            margin-left: 0 !important;\n            width: 100% !important;\n            margin-bottom: 8px;\n            height: 32px !important;\n          }\n\n          @media screen and (max-width: 1220px) and (min-width: $mobileWidth) {\n            max-width: 265px;\n            margin-left: 224px !important;\n            display: flex;\n            flex-direction: column;\n          }\n        }\n        .Box {\n          display: inline-block;\n          margin: 0 2mm 0 0;\n          border: 1px solid $Gray30;\n          border-radius: 4px;\n          cursor: pointer;\n          height: 35px;\n          width: 77px;\n          &__1 {\n            background: url(\"~images/header_underline.svg\") no-repeat center 12px;\n            background-size: 45px;\n          }\n          &__2 {\n            background: url(\"~images/header_background.svg\") no-repeat center 8px;\n            background-size: 45px;\n          }\n          &__3 {\n            background: url(\"~images/header_doubleLines.svg\") no-repeat center 8px;\n            background-size: 45px;\n          }\n          &__Active {\n            background-color: $Gray20;\n          }\n          @media screen and (max-width: 1220px) {\n            margin-bottom: 10px;\n          }\n        }\n        .CustomPremium {\n          margin: 8mm 0 5mm 0;\n\n          @media screen and (max-width: 1220px) and (min-width: $mobileWidth) {\n            margin-top: 120px;\n          }\n\n          .Label {\n            display: flex;\n            align-items: center;\n\n            img {\n              margin-left: 7px;\n              width: 12px;\n            }\n          }\n        }\n        .PremiumToggle {\n          display: inline-block;\n\n          @media screen and (min-width: $mobileWidth) {\n            max-width: 265px;\n            margin-left: 224px !important;\n          }\n\n          @media only screen and (max-width: $mobileWidth) {\n            max-width: 100%;\n            margin-left: 0 !important;\n            width: 100% !important;\n            height: 32px !important;\n          }\n\n          .PremiumText {\n            color: $Gray90;\n            font-size: 12px;\n            line-height: 15pt;\n            text-align: left;\n\n            @media only screen and (max-width: $mobileWidth) {\n              max-width: 100%;\n              margin-left: 0 !important;\n              width: 100% !important;\n              text-align: left;\n            }\n          }\n        }\n        .ColorPicker {\n          display: inline-block;\n\n          @media screen and (min-width: $mobileWidth) {\n            max-width: 265px;\n            margin-left: 224px !important;\n          }\n\n          @media only screen and (max-width: $mobileWidth) {\n            max-width: 100%;\n            margin-left: 0 !important;\n            width: 100% !important;\n            height: 32px !important;\n          }\n\n          p {\n            display: inline-block;\n            padding-top: 0;\n            padding-left: 10px;\n            line-height: 32px;\n            height: 100%;\n            position: absolute;\n          }\n          &__selected {\n            width: 29px;\n            height: 29px;\n            border-radius: 2px;\n            padding-top: 2px;\n          }\n          &__swatch {\n            border-radius: 1px;\n            box-shadow: 0 0 0 1px $Gray30;\n            display: inline-block;\n            cursor: pointer;\n          }\n          &__popover {\n            position: absolute;\n            z-index: 2;\n\n            .ColorContainer:before {\n              content: \"\";\n              background: $White;\n              width: 15px;\n              height: 15px;\n              transform: rotate(-45deg);\n              position: absolute;\n              box-shadow: 1px 4px 8px rgba(0, 0, 0, 0.5);\n              z-index: 3;\n              top: -7px;\n              left: 7px;\n            }\n\n            .ColorContainer {\n              position: relative;\n              background: none;\n              box-shadow: 1px 1px 12px $Gray90;\n              border-radius: 2px;\n              z-index: 2;\n\n              .InnerColorBox {\n                position: relative;\n                background: $White;\n                z-index: 4;\n              }\n\n              .ColorBox {\n                padding: 8px 8px 20px 16px;\n              }\n            }\n\n            input {\n              float: none !important;\n              margin-left: 0px !important;\n              border-radius: 2px;\n              border: solid 1px $Gray30;\n            }\n\n          }\n          &__cover {\n            position: fixed;\n            top: 0px;\n            right: 0px;\n            bottom: 0px;\n            left: 0px;\n          }\n        }\n        .poppins {\n          font-family: 'Poppins', sans-serif;\n        }\n        .roboto {\n          font-family: 'Roboto', sans-serif;\n        }\n        .robotoMono {\n          font-family: 'Roboto Mono', monospace;\n        }\n        .workSans {\n          font-family: 'Work Sans', sans-serif;\n        }\n        .playfair {\n          font-family: 'Playfair Display', serif;\n        }\n        .Quicksand {\n          font-family: 'Quicksand', sans-serif;\n        }\n        .libreBaskerville {\n          font-family: 'Libre Baskerville', serif;\n        }\n        .bitter {\n          font-family: 'Bitter', serif;\n        }\n        .varelaRound {\n          font-family: 'Varela Round', sans-serif;\n        }\n        .zillaSlab {\n          font-family: 'Zilla Slab', serif;\n        }\n        .volkhov {\n          font-family: 'Volkhov', serif;\n        }\n        .georama {\n          font-family: 'Georama', sans-serif;\n        }\n        .baskervville {\n          font-family: 'Baskervville', serif;\n        }\n        .arvo {\n          font-family: 'Arvo', serif;\n        }\n        .spaceMono {\n          font-family: 'Space Mono', monospace;\n        }\n        .rokkitt {\n          font-family: 'Rokkitt', serif;\n        }\n        .sen {\n          font-family: 'Sen', sans-serif;\n        }\n        .krub {\n          font-family: 'Krub', sans-serif;\n        }\n        .fahkwang {\n          font-family: 'Fahkwang', sans-serif;\n        }\n        .solway {\n          font-family: 'Solway', serif;\n        }\n        .robotoCondensed {\n          font-family: 'Roboto Condensed', sans-serif;\n        }\n        .ibmPlexSansCondensed {\n          font-family: 'IBM Plex Sans Condensed', sans-serif;\n        }\n      }\n    }\n  }\n}\n\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
